// client/src/components/marketer/MarketerSecbar.js
// 컨텍스트 칩바 (≤1024px) — 하단 탭바(1차)의 현재 탭에 속한 하위 화면만 노출하는 2차 내비.
// 확정 사양(2026-07-27, secbar-compare.html): 홈·등록 탭은 숨김, 블루 활성, 헤더 아래 sticky, 활성 칩 자동 스크롤.
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// 탭바의 탭 그룹별 하위 칩 (tab 쿼리 → 칩 목록)
const SUBNAV = {
  project: [
    ['진행중', 'project', 'prjOn'],
    ['선정', 'project', 'prjSelect'],
    ['검수', 'project', 'prjResult'],
    ['CPS 정산', 'project', 'prjCpsCharge'],
    ['완료 성과', 'project', 'prjFinish'],
    ['단가 통계', 'project', 'prjInfluencerStats'],
  ],
  point: [
    ['충전', 'point', 'pointCharge'],
    ['이용내역', 'point', 'pointList'],
    ['환불', 'point', 'pointRefund'],
  ],
  // 내 정보 탭은 my(계정)와 inquiry(고객센터)를 함께 담당 (탭바와 동일)
  my: [
    ['계정 정보', 'my', 'myInfo'],
    ['비밀번호', 'my', 'password'],
    ['진행 문의', 'inquiry', 'inqOn'],
    ['완료 문의', 'inquiry', 'inqFinish'],
  ],
};

// sub → 소속 탭 그룹 (탭바의 isActive 규칙과 일치)
function groupOf(tab, sub) {
  if (!sub || sub === 'home' || sub === 'prjCreate') return null; // 홈·등록은 칩바 숨김
  if (tab === 'project') return 'project';
  if (tab === 'point') return 'point';
  if (tab === 'my' || tab === 'inquiry') return 'my';
  return null;
}

function MarketerSecbar() {
  const nav = useNavigate();
  const location = useLocation();
  const barRef = useRef(null);

  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  const sub = params.get('sub');
  const group = groupOf(tab, sub);

  // 진입 시 활성 칩을 가운데로
  useEffect(() => {
    const active = barRef.current?.querySelector('.is-active');
    if (active?.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [group, sub]);

  if (!group) return null;

  return (
    <nav className="mb-secbar" ref={barRef} aria-label="현재 탭 하위 메뉴">
      {SUBNAV[group].map(([label, itemTab, itemSub]) => (
        <button
          key={itemSub}
          type="button"
          className={sub === itemSub ? 'is-active' : ''}
          onClick={() => nav(`/marketer/mybiz?tab=${itemTab}&sub=${itemSub}`)}
        >
          {label}
        </button>
      ))}
    </nav>
  );
}

export default MarketerSecbar;
